<script>
import auth from "../../../server/api/auth";
import mediaApi from "@/server/api/media";
import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { PERMISSIONS } from "./roles/menuAttrs";
import userInfoDialog from "@/components/dialog/userinfo.vue";
/**
 * Login component
 */
export default {
  components: {
    Layout,
    userInfoDialog,
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      httpError: "",
      checkAccount: "",
      accountList: [],
      loginFlag: true,
      groups: PERMISSIONS,
      pageLogin: false,
      subVerify: false,
      sendMsgDisabled: false,
      verify: {
        phone: "",
        verifyCode: "",
      },
      httpError: "",
      token: "",
      codeTime: 29,
      mediaId: undefined,
      toAuthentication: false,
      adminData: {},
      isValidated: 0, //为1代表密码登录后，为2代表验证码通过
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },

  created() {
    let app_token = this.utils.getQueryString(window.location.href, "token");
    if (app_token) {
      this.cookies.setCookie("token", app_token);
      this.$router.push({
        name: "dashboard",
      });
    }
  },
  beforeDestroy() {
    //未通过验证码验证跳转其它页面时清空数据
    console.log("即将销毁");
    if (this.isValidated == 1) {
      this.cookies.clearCookie("token");
      this.cookies.clearCookie("user");
      localStorage.setItem("power", "[]"); //清空权限
    }
  },

  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.cookies.clearCookie("token");
      this.cookies.clearCookie("user");
      localStorage.setItem("power", "[]"); //清空权限
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      this.httpError = "";
      if (this.$v.$invalid) {
        return;
      } else {
        // if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
        this.tryingToLogIn = true;
        // Reset the authError if it existed.
        this.authError = null;

        let params = {
          username: this.email,
          password: this.password,
        };
        console.log(params);
        auth.login(params).then((resp) => {
          console.log("第一次登录的数据", resp);
          if (resp.code === 0) {
            this.isValidated = 1;
          }
          if (resp.data) {
            this.pageLogin = false;
            this.loginFlag = false;
            this.token = resp.data.token;
            console.log("token", this.token);
            this.verify.phone = resp.data.phone;
            console.log("用户数据", resp.data);
            // this.cookies.setCookie("token", resp.data.token);
            // this.cookies.setCookie("user", JSON.stringify(resp.data));
            this.adminData = resp.data;
            return;
          } else {
            this.httpError = resp.msg;
            this.warning(resp.msg);
          }
        });
      }
    },
    getRelationMedia(adminId) {
      auth
        .getRelationMedia({
          adminId: adminId,
        })
        .then((res) => {
          console.log("关联媒体号列表", res);
          if (res.code === 0) {
            this.accountList = res.data;
            this.cookies.setCookie("userList", JSON.stringify(res.data));
            localStorage.mediaList = JSON.stringify(res.data);
          }
        });
    },
    getUserInfo() {
      let params = {
        userType: 1,
      };
      auth.userInfo(params).then((resp) => {
        console.log("登录账号的数据", resp);
        if (resp.data) {
          console.log(resp.data);
          this.verfiy.phone = resp.data.phone;
          this.cookies.setCookie("user", JSON.stringify(resp.data));
        }
      });
    },
    async toCheck() {
      this.mediaId = this.checkAccount.id;
      let check = false;
      await auth.checkAccount({ mediaId: this.mediaId }).then((res) => {
        if (res.code === 0) {
          console.log("检查结果", res);
          if (res.data.state == 1) {
            check = true;
          } else {
            check = false;
          }
        }
      });
      if (!check) {
        this.warning("您在该媒体号下的账号已被冻结");
        return;
      }
      // console.log(this.checkAccount);
      mediaApi.detail({ id: this.checkAccount.id }).then((res) => {
        console.log("媒体号详情", res);
        if (res.code === 0) {
          localStorage.chosedMedia = JSON.stringify(this.checkAccount);
          this.cookies.setCookie("token", this.token);
          this.getPowerInfo();
          // if (res.data.state === 1) {
          //   // this.cookies.setCookie(
          //   //   "chosedMedia",
          //   //   JSON.stringify(this.checkAccount)
          //   // );
          // } else {
          //   this.warning("媒体号状态异常,请更换媒体号");
          // }
        } else {
          this.warning("媒体号状态校验失败，请稍候重试");
        }
      });
    },
    getPowerInfo() {
      let params = { mediaId: this.mediaId };
      auth.power(params).then((resp) => {
        console.log("获取权限的参数", params);
        console.log("权限数据", resp);
        if (resp.code === 0) {
          // if (resp.data) {
          //   localStorage.setItem(
          //     "powerMenuAttrs",
          //     JSON.stringify(resp.data.menuAttrs)
          //   );
          // }
          if (resp.data && resp.data.menuAttrs) {
            this.setMenuAttrs(resp.data.menuAttrs);
          } else {
            this.setMenuAttrs([]);
          }
          this.$router.push({
            name: "dashboard",
          });
        } else {
          this.warning("权限数据获取失败，请稍候重试");
        }
      });
    },
    setMenuAttrs(items) {
      console.log(items);
      let groupsList = JSON.parse(JSON.stringify(this.groups));
      for (var i = 0; i < items.length; i++) {
        let key = items[i].key;
        for (let k in groupsList) {
          for (var f = 0; f < groupsList[k].length; f++) {
            let f_item = groupsList[k][f];
            if (key === f_item.key) {
              f_item.exists = true;
            }
          }
        }
      }
      localStorage.setItem("power", JSON.stringify(groupsList));
      // this.$router.push({
      //   name: "dashboard"
      // });
      // console.log(groupsList)
    },
    getPhoneCode() {
      let _this = this;
      if (!_this.verify.phone) {
        _this.httpError = "请输入手机号";
        return;
      }
      if (_this.sendMsgDisabled) {
        return;
      }
      _this.sendMsgDisabled = true;
      let params = {
        phone: _this.verify.phone,
      };
      auth
        .sendMsg(params)
        .then((resp) => {
          if (resp.code === 0) {
            _this.httpError = "";
            _this.sendMsgDisabled = true;
            let codeInterval = window.setInterval(function() {
              if (_this.codeTime-- <= 0) {
                _this.codeTime = 29;
                _this.sendMsgDisabled = false;
                window.clearInterval(codeInterval);
              }
            }, 1000);
          } else {
            this.httpError = resp.msg;
            _this.sendMsgDisabled = false;
          }
        })
        .catch(() => {
          _this.sendMsgDisabled = false;
        });
    },
    tryDaryLogin() {
      this.subVerify = true;
      if (!this.verify.phone || !Boolean(this.verify.verifyCode)) {
        this.httpError = "请输入验证码";
        return;
      }
      let params = {
        verifyCode: this.verify.verifyCode,
        adminToken: this.token,
      };
      let that = this;
      auth.verify(params).then((resp) => {
        console.log("验证码校验过后的数据", resp);
        if (resp.code === 0) {
          this.isValidated = 2;
          this.cookies.setCookie("token", this.token);
          this.getRelationMedia(this.adminData.id);
          this.cookies.setCookie("user", JSON.stringify(this.adminData));
          if (this.toAuthentication) {
            that.$router.push({
              name: "sso",
              query: that.$route.query,
            });
          } else {
            this.pageLogin = true;
          }
          // this.accountList = resp.data;
          // this.cookies.setCookie("userList", JSON.stringify(resp.data));
        } else if (resp.code === -2) {
          this.cookies.setCookie("token", this.token);
          //-2代表需要修改密码，首次登录
          this.info(resp.msg);
          this.$refs.userInfo.showModal(this.adminData);
        } else {
          this.httpError = resp.msg;
          this.warning(resp.msg);
        }
      });
    },
    toRegister() {
      window.location.pathname = "/register";
    },
    //数据重置
    toLogin() {
      this.cookies.clearCookie("token");
      this.cookies.clearCookie("user");
      this.pageLogin = true;
      this.tryingToLogIn = false;
      this.isAuthError = false;
      this.authError = null;
      this.submitted = false;
      this.httpError = "";
      this.sendMsgDisabled = false;
      this.codeTime = 29;
      this.email = "";
      this.password = "";
      this.verify = {};
      this.adminData = {};
      this.subVerify = false;
      this.accountList = [];
      this.loginFlag = true;
      this.token = "";
      this.mediaId = undefined;
    },
  },
  mounted() {
    if (this.$route.query.authentication == false) {
      this.toAuthentication = true;
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center app-login">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">汉新闻媒体号管理后台</h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      style="margin-top:-5px"
                      src="@/assets/images/logo_home@3x.png"
                      alt
                      height="68"
                    />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >
            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form v-if="loginFlag" class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="账号"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="请输入账号"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">账号不能为空</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="密码"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="请输入密码"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  密码不能为空
                </div>
              </b-form-group>
              <!-- <b-form-checkbox
                  class="form-check"
                  id="customControlInline"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  Remember me
                </b-form-checkbox> -->
              <div class="mt-3 d-grid">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  style="margin-top:5px"
                  >登录</b-button
                >

                <!-- <button
                  class="btn btn-outline-dark"
                  type="button"
                  @click="toRegister"
                  style="margin-top:10px"
                >
                  注册
                </button> -->
                <b-button
                  type="button"
                  @click="toRegister"
                  variant="outline-primary"
                  class="btn-block"
                  style="margin-top:15px"
                  >注册</b-button
                >
                <div v-if="httpError" class="http-error invalid-feedback">
                  <span>{{ httpError }}</span>
                </div>
              </div>

              <!-- <div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Sign in with</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-primary text-white border-primary"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div> -->
              <!-- <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> Forgot your password?
                </router-link>
              </div> -->
            </b-form>

            <div
              style="margin-bottom:50px"
              v-if="!loginFlag"
              v-show="pageLogin"
            >
              <h3 style="margin-bottom:30px" class="login_title">
                请选择要登录的媒体号
              </h3>
              <el-select
                @change="toCheck"
                style="width:100%;font-weight:bold"
                v-model="checkAccount"
                placeholder="请选择"
                value-key="id"
              >
                <el-option
                  v-for="(item, index) in accountList"
                  :key="index"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>

            <!-- 验证手机号 -->
            <div
              class="p-2"
              v-if="!pageLogin"
              autocomplete="off"
              v-show="!loginFlag"
            >
              <div class="login-title-text">验证手机号</div>
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="手机号"
                label-for="input-1"
              >
                <div class="get-verify-code-btn">
                  <b-form-input
                    v-model="verify.phone"
                    type="text"
                    disabled
                    placeholder="请输入手机号"
                    :class="{ 'is-invalid': subVerify && !verify.phone }"
                  ></b-form-input>
                  <b-button
                    size="sm"
                    variant="primary"
                    :disabled="sendMsgDisabled"
                    @click="getPhoneCode()"
                  >
                    <span v-if="!sendMsgDisabled">获取验证码</span>
                    <span v-if="sendMsgDisabled"
                      >{{ codeTime }}s后重新获取</span
                    >
                  </b-button>
                </div>

                <div v-if="subVerify && !verify.phone" class="invalid-feedback">
                  <span v-if="!verify.phone">手机号不能为空</span>
                </div>
              </b-form-group>
              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="验证码"
                label-for="input-2"
              >
                <b-form-input
                  v-model="verify.verifyCode"
                  type="text"
                  placeholder="请输入验证码"
                  :class="{ 'is-invalid': subVerify && !verify.verifyCode }"
                  @keyup.enter.native="tryDaryLogin"
                ></b-form-input>
                <div
                  v-if="subVerify && !verify.verifyCode"
                  class="invalid-feedback"
                >
                  验证码不能为空
                </div>
              </b-form-group>
              <div class="mt-3 d-grid">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  @click="tryDaryLogin"
                  >登录</b-button
                >
                <div v-if="httpError" class="http-error invalid-feedback">
                  <span>{{ httpError }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-skote text-center">
          <!-- <p>
            Don't have an account ?
            <router-link
              tag="a"
              to="/register"
              class="fw-medium text-primary"
              >Signup now</router-link
            >
          </p> -->
          <p>
            © 2022 武汉广播电视台
            <!-- <i class="mdi mdi-heart text-danger"></i> by Themesbrand -->
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
    <userInfoDialog :login="true" ref="userInfo" @change="toLogin" />
  </Layout>
</template>

<style>
.app-login .http-error {
  display: block;
}
.app-login .mt-skote {
  margin-top: 6rem !important;
}
.login_title {
  /* font-family: PingFangSC-S0pxibold; */
  font-weight: 600;
  font-size: 22px;
  color: #1b2733;
  letter-spacing: 0.17px;
}

.get-verify-code-btn {
  position: relative;
}

.get-verify-code-btn button {
  padding: 2px 0.5rem;
  position: absolute;
  right: 0.75rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.app-login .login-title-text {
  font-size: 17px;
  color: #556ee6;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
